export const FALLBACK_TENANT_ID =
  process.env.FALLBACK_TENANT_ID || "expotenant.com";

export enum SiteType {
  Brand = "BRAND_HUB",
  Audience = "AUDIENCE_HOME",
  Event = "EVENT",
  Course = "COURSE",
  Article = "ARTICLE",
  Industry = "L1_TOPIC_HUB",
}

export enum PreviewState {
  Published = "published",
  Draft = "preview",
}

export enum PublishedState {
  Published = "Published",
  Draft = "Draft",
}

export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = MS_PER_SECOND * 60;
export const MS_PER_HOUR = MS_PER_MINUTE * 60;
export const MS_PER_DAY = MS_PER_HOUR * 24;

export const CONTENT_TYPE = "Content-Type";
export const CACHE_CONTROL = "Cache-Control";
export const SURROGATE_CONTROL = "Surrogate-Control";
export const SURROGATE_KEY = "Surrogate-Key";
export const ETAG = "ETag";

export const CENTER_STAGE_PAGE_URL = "https://informaconnect.com/center-stage/";
